@if (!isInitialized) {
  <div
    class="initialize eshava-text-center">
    <h1> {{'ApplicationLoading'|translate:'assets'}}</h1>
    <div class="loading-bar">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
<router-outlet></router-outlet>